import type { NamedRef } from '@/types/api'
import type { BloodGroup, Gender } from '@/features/students/types'

export type EmploymentType = 'permanent' | 'contractual' | 'part_time'
export type StaffStatus = 'active' | 'on_leave' | 'resigned' | 'terminated'

export const EMPLOYMENT_TYPES: EmploymentType[] = ['permanent', 'contractual', 'part_time']
export const STAFF_STATUSES: StaffStatus[] = ['active', 'on_leave', 'resigned', 'terminated']

export interface StaffMember {
  id: number
  employeeCode: string
  firstName: string
  lastName: string
  fullName: string
  gender: Gender
  dateOfBirth: string | null
  bloodGroup: BloodGroup | null
  email: string | null
  phone: string | null
  address: string | null
  qualification: string | null
  department: NamedRef | null
  designation: NamedRef | null
  primarySubject: NamedRef | null
  employmentType: EmploymentType
  joiningDate: string | null
  leavingDate: string | null
  basicSalary: string | null
  status: StaffStatus
  photoUrl: string | null
  account: { id: number; email: string; role: string; isActive: boolean } | null
  classTeacherOf: NamedRef[]
  createdAt: string
}

export interface NamedItem {
  id: number
  name: string
  staffCount: number
}
